module.exports = __webpack_public_path__ + "img/shopping.0a8c39ed.svg";